/**
 * @returns {{}|any}
 */
const getLandingSession = () => {
  if (typeof sessionStorage === 'undefined' || !sessionStorage.landing) {
    return {};
  }

  return JSON.parse(sessionStorage.landing);
};

export default getLandingSession;
